import { HOTEL_CLASSES } from "@/app/lib/constants";
import { Checkbox, Divider } from "@mui/material";
import type { ChangeEvent } from "react";
import { useTranslations } from "use-intl";

type Props = {
  selectedClasses?: number[];
  userManuallySelectedAllClasses: boolean;
  onChange: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
    option: number,
  ) => void;
};

export const HotelClassFilter = ({
  selectedClasses = [],
  userManuallySelectedAllClasses,
  onChange,
}: Props) => {
  const t = useTranslations();

  const areAllClassesSelected = selectedClasses.length === HOTEL_CLASSES.length;

  return (
    <ul>
      {HOTEL_CLASSES.map((option) => (
        <li key={option}>
          <label className="flex w-full items-center justify-between py-2">
            <span className="font-medium text-text-primary">
              {t(`hotels.filters.stars.${option}`)}
            </span>
            <Checkbox
              checked={
                selectedClasses?.includes(option) &&
                (userManuallySelectedAllClasses || !areAllClassesSelected)
              }
              onChange={(e, checked) => onChange(e, checked, option)}
              sx={{ padding: "6px" }}
            />
          </label>
          <Divider />
        </li>
      ))}
    </ul>
  );
};
